"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopMenuSkeleton = exports.DesktopMenu = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_link_1 = require("@hotelplan/components.common.link");
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const graphql_types_1 = require("@hotelplan/graphql.types");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const DesktopMenuList_skeleton_1 = __importDefault(require("./DesktopMenuList.skeleton"));
const SubLinksListWrap = styled_components_1.default.div(({ theme, hide }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign(Object.assign({}, theme.menu.subLinksListWrap), { display: hide ? 'none' : 'flex' })));
const SubLinksList = styled_components_1.default.ul(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(theme.menu.subLinksList));
const SubMenuChevron = (0, styled_components_1.default)(components_common_icon_1.Icon).attrs({
    className: 'sub-link-chevron',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    ml: [1, 2],
    flexShrink: '0',
}));
const MenuListWrapper = styled_components_1.default.ul(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    '.sub-menu-link': theme.menu.navBarLink,
    '.nav-link': theme.menu.nav,
    '.menu-link-item': theme.menu.menuLinkItem,
    '.sub-menu-item': theme.menu.navBarItem,
}));
const LinkWrapper = (0, styled_components_1.default)(components_common_link_1.Link)(({ fontColor }) => fontColor
    ? {
        color: `${fontColor}`,
    }
    : {});
const MenuLinksList = ({ links, isSubMenuBlocked, onLinkClick, internalLinkIconName, }) => {
    const [hideSubMenu, setHideSubMenu] = (0, react_1.useState)(false);
    return (react_1.default.createElement(MenuListWrapper, null,
        react_1.default.createElement(MenuList, { links: links, onLinkClick: onLinkClick, isSubMenuBlocked: isSubMenuBlocked, hideSubMenu: hideSubMenu, setHideSubMenu: setHideSubMenu, internalLinkIconName: internalLinkIconName })));
};
const MenuList = ({ links = [], isSubMenu, positionIndex, isSubMenuBlocked = false, onLinkClick, hideSubMenu, setHideSubMenu, internalLinkIconName, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, links.map(({ label, link = { href: '' }, subLinks, target, iconType, fontColor }, i) => {
        return (react_1.default.createElement(react_1.default.Fragment, { key: i },
            react_1.default.createElement(MenuLink, { isSubMenu: isSubMenu, link: link, target: target, index: i, label: label, iconType: iconType, positionIndex: positionIndex, onClick: () => {
                    setHideSubMenu === null || setHideSubMenu === void 0 ? void 0 : setHideSubMenu(true);
                    onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(link, i, positionIndex);
                }, onLinkInteraction: () => {
                    setHideSubMenu === null || setHideSubMenu === void 0 ? void 0 : setHideSubMenu(false);
                }, subLinks: subLinks, dataId: `${isSubMenu ? 'sub-menu-link' : 'main-menu-link'}`, fontColor: fontColor, internalLinkIconName: internalLinkIconName }),
            subLinks && !isSubMenuBlocked && (react_1.default.createElement(SubLinksListWrap, { className: "sub-links-list", hide: hideSubMenu },
                react_1.default.createElement(SubLinksList, null,
                    react_1.default.createElement(MenuList, { isSubMenu: true, links: subLinks, positionIndex: i, onLinkClick: onLinkClick, setHideSubMenu: setHideSubMenu, internalLinkIconName: internalLinkIconName }))))));
    })));
};
const MenuLink = ({ isSubMenu, link, fontColor, target, index, label, positionIndex, onClick, subLinks, iconType, dataId, onLinkInteraction, internalLinkIconName, }) => {
    const menuItemClassName = (subLinks === null || subLinks === void 0 ? void 0 : subLinks.length) ? 'main-menu-chevron' : null;
    return (react_1.default.createElement("li", { className: `${isSubMenu ? 'sub-menu-item' : `menu-link-item ${menuItemClassName}`}`, "data-id": dataId },
        react_1.default.createElement(components_common_router_link_1.RouterLink, Object.assign({}, link, { passHref: true }),
            react_1.default.createElement(LinkWrapper, { className: `${isSubMenu ? 'sub-menu-link' : 'nav-link'}`, target: target, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(index, positionIndex), fontColor: fontColor, onMouseEnter: onLinkInteraction, onFocus: onLinkInteraction },
                label,
                isSubMenu && (react_1.default.createElement(SubMenuChevron, { name: iconType === graphql_types_1.IconType.External
                        ? `external-link`
                        : internalLinkIconName }))))));
};
const DesktopNavbar = styled_components_1.default.nav(({ theme }) => theme.menu.headerMenu || {}, (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: ['none', 'flex'],
    flexDirection: ['column', 'row'],
    px: 3,
    ml: [null, 'auto'],
}));
const DesktopMenu = props => {
    const { className, links, isSubMenuBlocked, onLinkClick, internalLinkIconName = `chevron-long-right`, } = props;
    return (react_1.default.createElement(DesktopNavbar, { className: className },
        react_1.default.createElement(MenuLinksList, { links: links, isSubMenuBlocked: isSubMenuBlocked, onLinkClick: onLinkClick, internalLinkIconName: internalLinkIconName })));
};
exports.DesktopMenu = DesktopMenu;
const DesktopMenuSkeleton = props => {
    const { className } = props;
    return (react_1.default.createElement(DesktopNavbar, { className: className },
        react_1.default.createElement(DesktopMenuList_skeleton_1.default, null)));
};
exports.DesktopMenuSkeleton = DesktopMenuSkeleton;
//# sourceMappingURL=DesktopMenu.js.map